// Scheduled times are stored as UTC ISO-8601 (the correct instant). Every
// user-facing surface must render them in Europe/London so a 13:00 BST booking
// reads as "13:00", not the stored 12:00Z. Single source of truth for the app.

const UK_OPTS = {
  timeZone: "Europe/London",
  weekday: "short",
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

// e.g. "Sat, 04 Jul, 13:00" in UK local time. Returns `fallback` for
// non-scheduled sentinels (asap/now/empty) and unparseable values.
export function formatUkDateTime(value, fallback = "—") {
  if (!value) return fallback;
  if (typeof value === "string" && ["asap", "now"].includes(value.trim().toLowerCase())) {
    return fallback;
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return typeof value === "string" ? value : fallback;
  return d.toLocaleString("en-GB", UK_OPTS).replace(/,(\s)(\d{2}:\d{2})$/, ", $2");
}

// A ride is "scheduled" when it carries a concrete future pickup time.
export function scheduledTime(ride) {
  const s = ride?.scheduled_for;
  if (!s || (typeof s === "string" && ["asap", "now"].includes(s.trim().toLowerCase()))) {
    return null;
  }
  return s;
}
